/* CS Landing v8 — carrusel deslizante, packs, sticky (Releasit), CTA, fecha, anuncios, FAQ animado,
   coreografía de entradas [data-cs-in], bucles ambientales pausables [data-cs-live], curva dibujada. */
(function(){
  'use strict';
  if (window.__csLandingInit) return; window.__csLandingInit = true;
  document.documentElement.classList.add('cs-js');

  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var HAS_IO = 'IntersectionObserver' in window;
  var raf = window.requestAnimationFrame ? function(f){ return window.requestAnimationFrame(f); } : function(f){ return setTimeout(f, 16); };

  function fmtThousands(str, sep){ return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function money(cents){
    var box = document.querySelector('[data-money-format]');
    var fmt = (box && box.getAttribute('data-money-format')) || (window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) || '${{amount_no_decimals_with_comma_separator}}';
    var n = cents/100, s;
    if (fmt.indexOf('amount_no_decimals_with_comma_separator') > -1) s = fmtThousands(Math.round(n).toString(), '.');
    else if (fmt.indexOf('amount_with_comma_separator') > -1) s = fmtThousands(n.toFixed(2).replace('.',','), '.');
    else if (fmt.indexOf('amount_no_decimals') > -1) s = fmtThousands(Math.round(n).toString(), ',');
    else s = fmtThousands(n.toFixed(2), ',');
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, s).replace(/<[^>]+>/g,'').replace(/([.,])00(?!\d)/, '');
  }

  /* ---------- Abrir Releasit con el pack elegido (hero y sticky) ---------- */
  function openReleasit(fromBtn){
    var form = fromBtn && fromBtn.closest('form');
    var rsi = (form && form.querySelector('#_rsi-buy-now-button')) || document.querySelector('#_rsi-buy-now-button._rsi-buy-now-button-product') || document.querySelector('#_rsi-buy-now-button');
    if (rsi){
      try { if (window._rsi && _rsi.form && _rsi.form.quantityOffers){ _rsi.form.quantityOffers.savedSelection = false; _rsi.form.quantityOffers.selectedOfferIn = false; } } catch(err){}
      rsi.click(); waitOpening(fromBtn); return true;
    }
    var fb = document.querySelector('[data-cs-cart-fallback]');
    if (fb){ fb.hidden = false; fb.click(); fb.hidden = true; return true; }
    return false;
  }
  /* Si Releasit tarda > 300 ms: "Abriendo…" con un punto que late (nunca un spinner) */
  function waitOpening(btn){
    if (!btn || btn.__opening) return;
    function modalOpen(){ var m = document.querySelector('#_rsi-cod-form-modal'); return !!(m && m.offsetHeight > 0 && getComputedStyle(m).visibility !== 'hidden'); }
    var t0 = Date.now(), html = btn.innerHTML;
    var wait = setTimeout(function(){
      if (modalOpen()) return;
      btn.__opening = true; btn.classList.add('is-opening'); btn.innerHTML = 'Abriendo<span class="cs-btn__dot" aria-hidden="true">.</span>';
      var poll = setInterval(function(){
        if (modalOpen() || Date.now() - t0 > 5000){ clearInterval(poll); btn.innerHTML = html; btn.classList.remove('is-opening'); btn.__opening = false; }
      }, 120);
    }, 300);
    var early = setInterval(function(){ if (modalOpen()){ clearTimeout(wait); clearInterval(early); } if (Date.now() - t0 > 400) clearInterval(early); }, 60);
  }
  function releasitCta(btn){
    if (btn.__cs) return; btn.__cs = true;
    btn.addEventListener('click', function(e){ e.preventDefault(); openReleasit(btn); });
  }

  /* ---------- Carrusel: pista deslizante + arrastre táctil ---------- */
  function carousel(root){
    if (root.__cs) return; root.__cs = true;
    var track = root.querySelector('[data-cs-track]');
    var slides = root.querySelectorAll('[data-cs-slide]'), dots = root.querySelectorAll('[data-cs-dot]'), thumbs = root.querySelectorAll('[data-cs-thumb]');
    var prev = root.querySelector('[data-cs-prev]'), next = root.querySelector('[data-cs-next]');
    var auto = parseInt(root.getAttribute('data-autoplay')||'0',10)*1000;
    var i = 0, timer = null, paused = false, n = slides.length;
    if (!n) return;
    function setX(px, animate){
      if (!track) return;
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translate3d(' + px + ',0,0)';
    }
    function go(k, animate){
      i = (k + n) % n;
      slides.forEach(function(s,idx){ s.classList.toggle('is-active', idx===i); s.setAttribute('aria-hidden', idx===i ? 'false' : 'true'); });
      dots.forEach(function(d,idx){ d.classList.toggle('is-active', idx===i); d.setAttribute('aria-selected', idx===i); });
      thumbs.forEach(function(t,idx){ t.classList.toggle('is-active', idx===i); });
      var img = slides[i].querySelector('img[loading="lazy"]'); if (img) img.loading = 'eager';
      setX((-i*100) + '%', animate !== false && !REDUCE);
    }
    function restart(){ if (!auto || n<2 || REDUCE) return; clearInterval(timer); timer = setInterval(function(){ if(!paused) go(i+1); }, auto); }
    dots.forEach(function(d,k){ d.addEventListener('click', function(){ go(k); restart(); }); });
    thumbs.forEach(function(t,k){ t.addEventListener('click', function(){ go(k); restart(); }); });
    if (prev) prev.addEventListener('click', function(){ go(i-1); restart(); });
    if (next) next.addEventListener('click', function(){ go(i+1); restart(); });
    root.addEventListener('mouseenter', function(){ paused = true; });
    root.addEventListener('mouseleave', function(){ paused = false; });
    /* Arrastre con pointer events: umbral 40 px, sigue el dedo, inercia simple por velocidad */
    var vp = root.querySelector('.cs-car__viewport') || root, x0 = null, t0 = 0, dx = 0, dragging = false, w = 1;
    function down(e){ if (n<2 || (e.pointerType === 'mouse' && e.button !== 0)) return; x0 = e.clientX; t0 = Date.now(); dx = 0; dragging = false; w = vp.clientWidth || 1; paused = true; }
    function move(e){
      if (x0 === null) return; dx = e.clientX - x0;
      if (!dragging && Math.abs(dx) > 8){ dragging = true; try { vp.setPointerCapture(e.pointerId); } catch(err){} }
      if (dragging){ if (e.cancelable) e.preventDefault(); var lim = w * .35, d = Math.max(-lim, Math.min(lim, dx)); setX('calc(' + (-i*100) + '% + ' + d + 'px)', false); }
    }
    function up(e){
      if (x0 === null) return; var dt = Math.max(1, Date.now() - t0), v = Math.abs(dx) / dt; x0 = null; paused = false;
      if (!dragging){ return; }
      dragging = false;
      if (Math.abs(dx) >= 40 || v > .5) go(dx < 0 ? i+1 : i-1); else go(i);
      restart();
      vp.__csClickBlock = true; setTimeout(function(){ vp.__csClickBlock = false; }, 60);
    }
    if (window.PointerEvent){
      vp.addEventListener('pointerdown', down, {passive:true});
      vp.addEventListener('pointermove', move, {passive:false});
      vp.addEventListener('pointerup', up); vp.addEventListener('pointercancel', up);
      vp.addEventListener('click', function(e){ if (vp.__csClickBlock){ e.preventDefault(); e.stopPropagation(); } }, true);
    } else {
      root.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; paused = true; }, {passive:true});
      root.addEventListener('touchend', function(e){ paused = false; if (x0 === null) return; var d = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(d) < 40) return; go(d < 0 ? i+1 : i-1); restart(); }, {passive:true});
    }
    document.addEventListener('visibilitychange', function(){ paused = document.hidden; });
    go(0, false); restart();
  }

  /* ---------- Fecha de entrega ---------- */
  function deliveryDate(el){
    if (el.__cs) return; el.__cs = true;
    var min = parseInt(el.getAttribute('data-min')||'3',10), max = parseInt(el.getAttribute('data-max')||'5',10);
    var d1 = new Date(), d2 = new Date(); d1.setDate(d1.getDate()+min); d2.setDate(d2.getDate()+max);
    var days = ['dom','lun','mar','mié','jue','vie','sáb'], months = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    function f(d, withMonth){ return days[d.getDay()] + ' ' + d.getDate() + (withMonth ? ' de ' + months[d.getMonth()] : ''); }
    el.textContent = 'entre ' + f(d1, d1.getMonth() !== d2.getMonth()) + ' y ' + f(d2, true);
  }

  /* ---------- Anuncios rotativos ---------- */
  function announce(root){
    if (root.__cs) return; root.__cs = true;
    var items = root.querySelectorAll('.cs-announce__item'); if (items.length < 2) { if(items[0]) items[0].classList.add('is-active'); return; }
    var i = 0, ms = parseInt(root.getAttribute('data-interval')||'4',10)*1000;
    function go(n){ i=(n+items.length)%items.length; items.forEach(function(it,k){ it.classList.toggle('is-active',k===i); }); }
    var t = REDUCE ? null : setInterval(function(){ go(i+1); }, ms);
    function reset(){ if (t){ clearInterval(t); t = setInterval(function(){ go(i+1); }, ms); } }
    var p = root.querySelector('[data-cs-prev]'), nx = root.querySelector('[data-cs-next]');
    if (p) p.addEventListener('click', function(){ go(i-1); reset(); });
    if (nx) nx.addEventListener('click', function(){ go(i+1); reset(); });
    go(0);
  }

  /* ---------- FAQ por pestañas ---------- */
  function faqTabs(root){
    if (root.__cs) return; root.__cs = true;
    var tabs = root.querySelectorAll('.cs-faq__tab'), panels = root.querySelectorAll('.cs-faq__panel');
    tabs.forEach(function(t){ t.addEventListener('click', function(){
      var key = t.getAttribute('data-tab');
      tabs.forEach(function(x){ x.classList.toggle('is-active', x===t); });
      panels.forEach(function(p){ p.hidden = p.getAttribute('data-tab') !== key; if (!p.hidden) p.querySelectorAll('[data-cs-in]').forEach(function(el){ el.classList.add('is-in'); }); });
    }); });
  }

  /* ---------- Acordeones <details> con altura animada (grid 0fr → 1fr) ---------- */
  function accordion(d){
    if (d.__cs) return; d.__cs = true;
    var sum = d.querySelector('summary'), body = d.querySelector('.cs-acc__body'); if (!sum || !body) return;
    var busy = false;
    sum.addEventListener('click', function(e){
      if (REDUCE) return; e.preventDefault(); if (busy) return; busy = true;
      if (!d.open){
        body.classList.add('is-closed'); d.open = true; void body.offsetHeight;
        body.classList.remove('is-closed');
        setTimeout(function(){ busy = false; }, 340);
      } else {
        body.classList.add('is-closed');
        var done = false; function end(){ if (done) return; done = true; body.removeEventListener('transitionend', end); d.open = false; body.classList.remove('is-closed'); busy = false; }
        body.addEventListener('transitionend', end); setTimeout(end, 380);
      }
    });
  }

  /* ---------- Tira horizontal ---------- */
  function strip(root){
    if (root.__cs) return; root.__cs = true;
    var track = root.querySelector('[data-cs-strip-track]'); if (!track) return;
    function step(){ var it = track.firstElementChild; return it ? it.getBoundingClientRect().width + 12 : 300; }
    var p = root.querySelector('[data-cs-strip-prev]'), n = root.querySelector('[data-cs-strip-next]');
    if (p) p.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
    if (n) n.addEventListener('click', function(){ track.scrollBy({left:step(), behavior:'smooth'}); });
  }

  /* ---------- Comparativa: indicio de scroll horizontal ---------- */
  function compareScroll(wrap){
    if (wrap.__cs) return; wrap.__cs = true;
    function check(){ var more = wrap.scrollWidth - wrap.clientWidth - wrap.scrollLeft > 8; wrap.classList.toggle('has-more', more); }
    wrap.addEventListener('scroll', check, {passive:true}); window.addEventListener('resize', check); check(); setTimeout(check, 800);
  }

  /* ---------- Packs: cantidad, precio, ahorro, sticky ---------- */
  function packs(box){
    if (box.__cs) return; box.__cs = true;
    var qtyInput = box.querySelector('input[name="quantity"]');
    var idInput = box.querySelector('input[name="id"], select[name="id"]');
    var btnPrice = box.querySelector('[data-cs-btn-price]');
    var saveEl = box.querySelector('[data-cs-save-text]');
    var bundles = box.querySelectorAll('.cs-bundle');
    var firstRun = true;
    function tick(el){ if (!el || REDUCE) return; el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); }
    function select(b){
      bundles.forEach(function(x){ x.classList.toggle('is-selected', x===b); });
      var r=b.querySelector('input[type=radio]'); if (r) r.checked=true;
      var qty = parseInt(b.dataset.qty||'1',10), now = parseInt(b.dataset.now||'0',10), was = parseInt(b.dataset.was||'0',10), variant = b.dataset.variant || '';
      if (variant && idInput){ idInput.value = variant; if (qtyInput) qtyInput.value = 1; } else if (qtyInput) qtyInput.value = qty;
      if (btnPrice){ btnPrice.textContent = money(now); if (!firstRun) tick(btnPrice); }
      if (saveEl){
        var txt = (was > now) ? ('Ahorra ' + money(was-now) + ' frente a comprar ' + qty + ' por separado') : '';
        if (firstRun || REDUCE){ saveEl.textContent = txt; }
        else { saveEl.classList.add('is-fade'); setTimeout(function(){ saveEl.textContent = txt; saveEl.classList.remove('is-fade'); }, 150); }
      }
      document.querySelectorAll('[data-cs-sticky-price]').forEach(function(p){ p.textContent = money(now); if (!firstRun) tick(p); });
      document.querySelectorAll('[data-cs-sticky-label]').forEach(function(p){ p.textContent = b.dataset.label || ''; });
      document.querySelectorAll('[data-cs-sticky-img]').forEach(function(img){
        if (!b.dataset.thumb || img.src === b.dataset.thumb) return;
        if (firstRun || REDUCE){ img.src = b.dataset.thumb; img.hidden = false; return; }
        img.classList.add('is-swap'); setTimeout(function(){ img.src = b.dataset.thumb; img.hidden = false; img.classList.remove('is-swap'); }, 200);
      });
    }
    bundles.forEach(function(b){ b.addEventListener('click', function(){ select(b); }); });
    var pre = box.querySelector('.cs-bundle.is-selected') || bundles[0];
    if (pre) select(pre);
    firstRun = false;
  }

  /* ---------- Sticky: visible cuando el CTA del hero sale por arriba; oculto sobre el cierre ---------- */
  function sticky(){
    var bar = document.querySelector('[data-cs-sticky]'), anchor = document.querySelector('[data-cs-main-atc]') || document.getElementById('cs-oferta');
    if (!bar || !anchor || bar.__cs) return; bar.__cs = true;
    var waEls = null, pastHero = false, onFinal = false;
    var finalSec = document.querySelector('.cs-final'); finalSec = finalSec && (finalSec.closest('.shopify-section') || finalSec);
    function findWa(){
      if (waEls && waEls.length) return waEls; waEls = [];
      function add(el){ if (el && getComputedStyle(el).position === 'fixed' && waEls.indexOf(el) < 0) waEls.push(el); }
      document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp"], [class*="whatsapp"], [id*="whatsapp"], [class*="wa-widget"], [class*="WhatsApp"], #chat-bubble').forEach(function(el){
        var fixed = el; for (var k=0; k<4 && fixed; k++){ if (getComputedStyle(fixed).position === 'fixed') { add(fixed); return; } fixed = fixed.parentElement; }
        [].slice.call(el.querySelectorAll('*'), 0, 80).forEach(function(c){ if (c.offsetWidth <= 120 && c.offsetHeight <= 120) add(c); });
      });
      return waEls;
    }
    function apply(){
      var on = pastHero && !onFinal;
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('cs-sticky-on', on);
      findWa().forEach(function(el){
        el.style.setProperty('transition', 'transform 320ms cubic-bezier(.16,1,.3,1)', 'important');
        if (on){ el.style.setProperty('transform', 'translateY(-84px) scale(.8)', 'important'); el.style.setProperty('transform-origin', 'bottom right', 'important'); }
        else { el.style.removeProperty('transform'); el.style.removeProperty('transform-origin'); }
      });
    }
    function check(){ pastHero = anchor.getBoundingClientRect().bottom < 0; if (finalSec){ var r = finalSec.getBoundingClientRect(); onFinal = r.top < window.innerHeight && r.bottom > 0; } apply(); }
    if (HAS_IO){
      new IntersectionObserver(function(entries){ entries.forEach(function(en){ pastHero = !en.isIntersecting && en.boundingClientRect.bottom < 0; }); apply(); }, {threshold:0}).observe(anchor);
      if (finalSec) new IntersectionObserver(function(entries){ entries.forEach(function(en){ onFinal = en.isIntersecting; }); apply(); }, {threshold:0}).observe(finalSec);
    }
    var lastY = window.pageYOffset, upAcc = 0;
    window.addEventListener('scroll', function(){
      var y = window.pageYOffset, dy = y - lastY; lastY = y;
      if (dy < 0){ upAcc += -dy; if (upAcc > 120) bar.classList.add('is-compact'); } else if (dy > 0){ upAcc = 0; bar.classList.remove('is-compact'); }
      raf(check);
    }, {passive:true});
    check();
  }

  /* ---------- Scroll a la caja de oferta ---------- */
  function scrollBuy(a){
    if (a.__cs) return; a.__cs = true;
    a.addEventListener('click', function(e){
      var t=document.getElementById('cs-oferta')||document.querySelector('[data-cs-buy]'); if(!t) return;
      e.preventDefault();
      var y = Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - 16);
      try { window.scrollTo({top:y, behavior: REDUCE ? 'auto' : 'smooth'}); } catch(err){ window.scrollTo(0,y); }
      setTimeout(function(){ if (Math.abs(window.pageYOffset - y) > 80) window.scrollTo(0, y); }, 700);
    });
  }
  function scrollTo(a){
    if (a.__cs) return; a.__cs = true;
    a.addEventListener('click', function(e){
      var id = (a.getAttribute('href')||'').replace('#',''); var t = id && document.getElementById(id); if (!t) return;
      e.preventDefault(); var y = Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - 12);
      try { window.scrollTo({top:y, behavior: REDUCE ? 'auto' : 'smooth'}); } catch(err){ window.scrollTo(0,y); }
    });
  }

  /* ---------- Coreografía de entradas: [data-cs-in] + --i por grupo, un solo IO ---------- */
  var ENTRIES = [
    /* [selector, tipo, opciones] — se asignan como atributos; el hero trae los suyos en el HTML */
    ['.cs-section .cs-h2', 'rise'],
    ['.cs-section .cs-eyebrow', 'fade'],
    ['.cs-section .cs-lead, .cs-section .cs-mech__tag', 'rise'],
    ['.cs-ugc__item', 'rise', {group:'.cs-ugc__strip'}],
    ['.cs-problem__img', 'clip'],
    ['.cs-problem__text, .cs-problem__list li', 'rise', {group:'.cs-problem__body'}],
    ['.cs-night', 'draw'],
    ['.cs-pillar', 'pillar', {group:'.cs-pillars'}],
    ['.cs-benefits__img', 'clip'],
    ['.cs-mech__step', 'rise', {group:'.cs-mech', stagger:180}],
    ['.cs-stat', 'scale', {group:'.cs-stats'}],
    ['.cs-timeline span', 'rise', {group:'.cs-timeline', stagger:90, after:1400}],
    ['.cs-seal', 'scale', {group:'.cs-seals', stagger:60}],
    ['.cs-compare tbody tr', 'row', {group:'.cs-compare tbody', stagger:60}],
    ['.cs-compare thead tr', 'fade'],
    ['.cs-ingredient', 'ing', {group:'.cs-ingredients'}],
    ['.cs-how__item', 'how', {group:'.cs-how', stagger:180}],
    ['.cs-faq details', 'fade', {group:'.cs-faq__panel', stagger:50}],
    ['.cs-faq__tabs', 'fade'],
    ['.cs-final__pic', 'clip'],
    ['.cs-final__body', 'rise']
  ];
  function entries(){
    var io = null;
    function show(el){
      el.classList.add('is-in');
      if (el.classList.contains('cs-stat')) countUp(el.querySelector('.cs-stat__num'));
      if (el.classList.contains('cs-proof__fill')) { /* la barra se llena por CSS */ }
    }
    if (HAS_IO && !REDUCE){
      io = new IntersectionObserver(function(list){ list.forEach(function(en){ if (!en.isIntersecting) return; show(en.target); io.unobserve(en.target); }); }, {threshold:.18, rootMargin:'0px 0px -8% 0px'});
    }
    ENTRIES.forEach(function(def){
      var sel = def[0], type = def[1], opt = def[2] || {};
      var groups = {};
      document.querySelectorAll(sel).forEach(function(el){
        if (el.hasAttribute('data-cs-in') || el.closest('.cs-hero')) return;
        el.setAttribute('data-cs-in', type);
        var g = opt.group ? el.closest(opt.group) : null, key = g ? (g.__csg || (g.__csg = 'g' + Math.random())) : null;
        if (key){ groups[key] = (groups[key] || 0); el.style.setProperty('--i', groups[key]++); }
        if (opt.stagger) el.style.setProperty('--cs-stagger', opt.stagger + 'ms');
        if (opt.after) el.style.setProperty('--cs-after', opt.after + 'ms');
      });
    });
    var all = document.querySelectorAll('[data-cs-in]:not(.is-in), .cs-proof__fill:not(.is-in)');
    all.forEach(function(el){
      if (el.closest('.cs-hero')) return; /* el hero tiene su propia secuencia de carga */
      var r = el.getBoundingClientRect();
      if (REDUCE || !io || el.offsetParent === null || (r.top < window.innerHeight * .92 && r.bottom > 0)) show(el); else io.observe(el);
    });
    /* Barrido de seguridad: nada se queda invisible si un observer no dispara */
    var ticking = false;
    function sweep(){ ticking = false; document.querySelectorAll('[data-cs-in]:not(.is-in), .cs-proof__fill:not(.is-in)').forEach(function(el){ var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) show(el); }); }
    window.addEventListener('scroll', function(){ if (!ticking){ ticking = true; raf(sweep); } }, {passive:true});
    setTimeout(sweep, 2500);
  }

  /* ---------- Hero: secuencia de carga (≈ 1,2 s) ---------- */
  function heroLoad(){
    var hero = document.querySelector('.cs-hero'); if (!hero || hero.__cs) return; hero.__cs = true;
    var els = hero.querySelectorAll('[data-cs-in]'), fill = hero.querySelector('.cs-proof__fill');
    if (REDUCE){ els.forEach(function(el){ el.classList.add('is-in'); }); if (fill) fill.classList.add('is-in'); hero.classList.add('is-in'); return; }
    var offer = hero.querySelector('.cs-offer'), done = false;
    function run(){
      if (done) return; done = true;
      hero.classList.add('is-in');
      els.forEach(function(el){ el.classList.add('is-in'); });
      if (fill) setTimeout(function(){ fill.classList.add('is-in'); }, 600);
      if (offer) setTimeout(function(){ offer.classList.add('is-loaded'); }, 1500);
    }
    raf(function(){ raf(run); });
    setTimeout(run, 1500); /* red de seguridad si rAF no corre (pestaña en segundo plano) */
    if (fill) fill.addEventListener('transitionend', function(){ var t = hero.querySelector('.cs-proof__text'); if (t){ t.classList.remove('is-tick'); void t.offsetWidth; t.classList.add('is-tick'); } });
  }

  /* ---------- Movimiento premium: marca elementos vivos y expone progreso de scroll ---------- */
  function premiumMotion(){
    if (REDUCE) return;
    var live = '.cs-hero, .cs-car, .cs-btn--sheen, .cs-mech__img, .cs-pillar__photo, .cs-ingredient__photo, .cs-how__img, .cs-final__pic, .cs-final .cs-btn, .cs-seals, .cs-seals-row, .cs-announce, .cs-compare__pic, .cs-stat';
    document.querySelectorAll(live).forEach(function(el){
      if (!el.hasAttribute('data-cs-live')) el.setAttribute('data-cs-live', '');
    });
    var ticking = false;
    function update(){
      ticking = false;
      var h = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var p = Math.min(1, Math.max(0, window.pageYOffset / h));
      document.documentElement.style.setProperty('--cs-scroll', p.toFixed(4));
      document.documentElement.classList.toggle('cs-has-scrolled', window.pageYOffset > 24);
    }
    window.addEventListener('scroll', function(){ if (!ticking){ ticking = true; raf(update); } }, {passive:true});
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Bucles ambientales: solo en pantalla (.is-live) ---------- */
  function liveLoops(){
    var els = document.querySelectorAll('[data-cs-live]'); if (!els.length || REDUCE) return;
    if (!HAS_IO){ return; }
    var io = new IntersectionObserver(function(list){ list.forEach(function(en){ en.target.classList.toggle('is-live', en.isIntersecting); }); }, {threshold:0, rootMargin:'40px 0px'});
    els.forEach(function(el){ if (!el.__csl){ el.__csl = true; io.observe(el); } });
  }

  /* ---------- Parallax mínimo (6 px) en fotos de beneficios, solo escritorio ---------- */
  function parallax(){
    if (REDUCE || window.innerWidth < 900) return;
    var photos = document.querySelectorAll('.cs-pillar__photo img'); if (!photos.length) return;
    var ticking = false;
    function update(){
      ticking = false; var vh = window.innerHeight;
      photos.forEach(function(img){ var r = img.parentElement.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return; var p = (r.top + r.height/2 - vh/2) / vh; img.style.transform = 'translate3d(0,' + (p * 6).toFixed(2) + 'px,0) scale(1.04)'; });
    }
    window.addEventListener('scroll', function(){ if (!ticking){ ticking = true; raf(update); } }, {passive:true}); update();
  }

  /* ---------- Contador (ease-out expo, 1,4 s); "1 de cada 2" no cuenta, escala ---------- */
  function countUp(el){
    if (!el || el.__cs) return; el.__cs = true;
    var txt = el.textContent, m = txt.match(/(\d+(?:[.,]\d+)?)/); if (!m || REDUCE || /de cada/i.test(txt)) return;
    var raw = m[1], dec = (raw.split(/[.,]/)[1]||'').length, sep = raw.indexOf(',')>-1 ? ',' : '.';
    var target = parseFloat(raw.replace(',','.')), start = null, dur = 1400;
    function fmt(v){ return dec ? v.toFixed(dec).replace('.', sep) : Math.round(v).toString(); }
    function step(ts){ if (!start) start = ts; var p = Math.min(1, (ts-start)/dur); var e = p === 1 ? 1 : 1 - Math.pow(2, -10 * p); el.textContent = txt.replace(raw, fmt(target*e)); if (p<1) raf(step); else el.textContent = txt; }
    raf(step);
  }

  /* ---------- Pista única: el chevron del primer acordeón cerrado baja 3 px al entrar en pantalla ---------- */
  function nudges(){
    if (REDUCE || !HAS_IO) return;
    var groups = document.querySelectorAll('.cs-accordion, .cs-faq__panel'); if (!groups.length) return;
    var io = new IntersectionObserver(function(list){ list.forEach(function(en){
      if (!en.isIntersecting) return; io.unobserve(en.target);
      var d = en.target.querySelector('details:not([open])'); if (d) d.classList.add('cs-nudge');
    }); }, {threshold:.3});
    groups.forEach(function(g){ if (!g.__csn){ g.__csn = true; io.observe(g); } });
  }

  function init(){
    document.querySelectorAll('[data-cs-carousel]').forEach(carousel);
    document.querySelectorAll('[data-cs-strip]').forEach(strip);
    /* Modo COD Form Caseteja: la app engancha [data-cs-cta="cod"] (selector de la incrustación) y abre su formulario.
       El sticky y cualquier otro botón "releasit" reenvían el clic al principal. Si la app no cargó, se agrega al carrito. */
    var codMain = document.querySelector('[data-cs-main-atc][data-cs-cta="cod"]');
    if (codMain){
      document.querySelectorAll('[data-cs-cta="releasit"]').forEach(function(b){
        b.setAttribute('data-cs-cta', 'cod-proxy');
        b.addEventListener('click', function(e){ e.preventDefault(); codMain.click(); });
      });
      codMain.addEventListener('click', function(){
        /* si la app enganchó el botón, su listener (captura) ya detuvo el evento y no llegamos aquí */
        if (codMain.hasAttribute('data-cod-hooked')) return;
        var fb = codMain.parentElement && codMain.parentElement.querySelector('[data-cs-cart-fallback]');
        if (fb){ fb.hidden = false; fb.click(); fb.hidden = true; }
      });
    }
    document.querySelectorAll('[data-cs-cta="releasit"]').forEach(releasitCta);
    document.querySelectorAll('[data-cs-buy]').forEach(packs);
    document.querySelectorAll('[data-cs-scroll-buy]').forEach(scrollBuy);
    document.querySelectorAll('[data-cs-scroll-to]').forEach(scrollTo);
    document.querySelectorAll('[data-cs-delivery]').forEach(deliveryDate);
    document.querySelectorAll('[data-cs-announce]').forEach(announce);
    document.querySelectorAll('[data-cs-faq-tabs]').forEach(faqTabs);
    document.querySelectorAll('.cs-faq details, .cs-accordion details').forEach(accordion);
    document.querySelectorAll('[data-cs-compare-scroll]').forEach(compareScroll);
    heroLoad(); sticky(); entries(); premiumMotion(); liveLoops(); parallax(); nudges();
    document.querySelectorAll('.cs product-form').forEach(function(pf){
      if (pf.__cs) return; pf.__cs = true;
      pf.addEventListener('add-to-cart', function(){
        var sb = document.getElementById('site-cart-sidebar');
        if (sb && typeof sb.show === 'function' && !document.body.classList.contains('template-cart')) sb.show();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
